(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hagesaks-business-contact"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', (event) => {
    const choice = event.target;
    if (!(choice instanceof HTMLInputElement) || !choice.matches('[data-hg-business-type]')) return;
    const form = choice.closest('form');
    const label = form?.querySelector('[data-hg-business-message-label]');
    const message = form?.querySelector('[data-hg-business-message]');
    const type = choice.dataset.hgBusinessType;
    if (label && message && (type === 'business' || type === 'dealer')) {
      label.textContent = label.dataset[type];
      message.placeholder = message.dataset[type];
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
